import {
  TRAINING_REGISTRATION_PAGE_UPDATE_REQUEST_STATE,
  TRAINING_REGISTRATION_PAGE_RESET_STATE,
} from '../constants/actionTypes'

import {
  REQ_SUBMIT_TRAINING_REGISTRATION_DETAILS,
} from '../constants/requestTypes'

import {
  REQUEST_UNSTARTED,
  REQUEST_SUCCESS
} from '../constants/requestStates'

import { combineReducers } from 'redux';


const defaultRequestResults = {
  [REQ_SUBMIT_TRAINING_REGISTRATION_DETAILS]: {state: REQUEST_UNSTARTED},
}
function requestResults(
  state = defaultRequestResults, action) {
  switch (action.type) {
    case TRAINING_REGISTRATION_PAGE_UPDATE_REQUEST_STATE:
      return {...state, [action.key]: {...action.payload}};
    case TRAINING_REGISTRATION_PAGE_RESET_STATE:
      return defaultRequestResults;
    default:
      return state;
  }
}

export default combineReducers({
  requestResults,
});
